import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Flexbox Layout"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "flexbox-layout"
    }}>{`Flexbox Layout`}</h1>
    <p>{`Create a simple page layout component with header and footer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true xray=true",
        "live": "true",
        "xray": "true"
      }}>{`<div
  sx={{
    display: 'flex',
    flexDirection: 'column',
    // set this to \`minHeight: '100vh'\` for full viewport height
    minHeight: 256,
  }}>
  <header
    sx={{
      width: '100%',
    }}>
    Header
  </header>
  <main
    sx={{
      width: '100%',
      flex: '1 1 auto',
    }}>
    Main
  </main>
  <footer
    sx={{
      width: '100%',
    }}>
    Footer
  </footer>
</div>
`}</code></pre>
    <p>{`Flexbox styles are used to ensure the footer always renders at the bottom of the page, even when there isn't enough content to fill the viewport.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

export default (props) => (
  <div
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}>
    <header
      sx={{
        width: '100%',
      }}>
      Header
    </header>
    <main
      sx={{
        width: '100%',
        flex: '1 1 auto',
      }}>
      {props.children}
    </main>
    <footer
      sx={{
        width: '100%',
      }}>
      Footer
    </footer>
  </div>
)
`}</code></pre>
    <h2 {...{
      "id": "centered-containers"
    }}>{`Centered Containers`}</h2>
    <p>{`Centered, max-width containers can be added to the layout.`}</p>
    <p>{`First, add a `}<inlineCode parentName="p">{`container`}</inlineCode>{` size to your theme.
This will be used for the max-width of the content.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme
export default {
  sizes: {
    container: 768,
  },
}
`}</code></pre>
    <p>{`Next create a `}<inlineCode parentName="p">{`Container`}</inlineCode>{` component and use it within the layout.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

const Container = (props) => (
  <div
    {...props}
    sx={{
      maxWidth: 'container',
      mx: 'auto',
      px: 3,
    }}
  />
)

export default (props) => (
  <div
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}>
    <header
      sx={{
        width: '100%',
      }}>
      <Container>Header</Container>
    </header>
    <main
      sx={{
        width: '100%',
        flex: '1 1 auto',
      }}>
      <Container>{props.children}</Container>
    </main>
    <footer
      sx={{
        width: '100%',
      }}>
      <Container>Footer</Container>
    </footer>
  </div>
)
`}</code></pre>
    <h2 {...{
      "id": "make-it-themeable"
    }}>{`Make it Themeable`}</h2>
    <p>{`Add `}<inlineCode parentName="p">{`variant`}</inlineCode>{` keys to the layout components to allow the styles to be customized in the theme object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

const Container = (props) => (
  <div
    {...props}
    sx={{
      maxWidth: 'container',
      mx: 'auto',
      px: 3,
    }}
  />
)

export default (props) => (
  <div
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      variant: 'layout.root',
    }}>
    <header
      sx={{
        width: '100%',
        variant: 'layout.header',
      }}>
      <Container>Header</Container>
    </header>
    <main
      sx={{
        width: '100%',
        flex: '1 1 auto',
        variant: 'layout.main',
      }}>
      <Container>{props.children}</Container>
    </main>
    <footer
      sx={{
        width: '100%',
        variant: 'layout.footer',
      }}>
      <Container>Footer</Container>
    </footer>
  </div>
)
`}</code></pre>
    <p>{`With the `}<inlineCode parentName="p">{`variant`}</inlineCode>{` keys added above, you can adjust the layout styles at the theme level.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme
export default {
  sizes: {
    container: 768,
  },
  layout: {
    header: {
      color: 'white',
      bg: 'black',
    },
    footer: {
      bg: 'gray',
    },
  },
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      